import React, { useState } from 'react';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import {
  Badge,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { useNotifications } from '../hooks/useNotifications';

function formatNotificationWhen(value: string | null): string {
  if (!value) {
    return '';
  }
  const date = new Date(value.includes('T') ? value : `${value}Z`);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

const NotificationBell: React.FC = () => {
  const { notifications, unreadCount, markRead } = useNotifications();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        aria-label="Notifications"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge badgeContent={unreadCount} color="error" max={99}>
          <NotificationsNoneOutlinedIcon />
        </Badge>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { width: 360, maxHeight: 400 } } }}
      >
        {notifications.length === 0 ? (
          <MenuItem disabled>
            <Typography variant="body2" color="text.secondary">
              No notifications
            </Typography>
          </MenuItem>
        ) : (
          notifications.map((item) => {
            const when = formatNotificationWhen(item.create_date);
            return (
              <MenuItem
                key={item.id}
                onClick={() => {
                  if (!item.is_read) {
                    void markRead(item.id);
                  }
                }}
                sx={{
                  opacity: item.is_read ? 0.55 : 1,
                  alignItems: 'flex-start',
                  whiteSpace: 'normal',
                  py: 1.25,
                }}
              >
                <Box sx={{ width: '100%' }}>
                  {when ? (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ mt: 0.5, display: 'block' }}
                    >
                      {when}
                    </Typography>
                  ) : null}
                  <Typography
                    variant="body1"
                    fontWeight={item.is_read ? 400 : 600}
                  >
                    {item.title}
                  </Typography>
                  {item.body ? (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        mt: 0.25,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                      }}
                    >
                      {item.body}
                    </Typography>
                  ) : null}
                </Box>
              </MenuItem>
            );
          })
        )}
      </Menu>
    </>
  );
};

export default NotificationBell;
